var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var DetailSection = /** @class */ (function () {
    function DetailSection() {
        this.data = [];
        //This is temp until they rename ->
        this.map = new Coordinate();
        // ->
    }
    return DetailSection;
}());
export { DetailSection };
var EntryRequirementsDetailSection = /** @class */ (function (_super) {
    __extends(EntryRequirementsDetailSection, _super);
    function EntryRequirementsDetailSection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tariff = [];
        return _this;
    }
    return EntryRequirementsDetailSection;
}(DetailSection));
export { EntryRequirementsDetailSection };
var Coordinate = /** @class */ (function () {
    function Coordinate() {
    }
    return Coordinate;
}());
export { Coordinate };



// WEBPACK FOOTER //
// ./src/app/models/courses/detailSection.model.ts.pre-build-optimizer.js